import { render, staticRenderFns } from "./CreateCategory.vue?vue&type=template&id=01ce667f&scoped=true"
import script from "./CreateCategory.vue?vue&type=script&lang=js"
export * from "./CreateCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateCategory.vue?vue&type=style&index=0&id=01ce667f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ce667f",
  null
  
)

export default component.exports